var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.price_model,
        expression: "price_model"
      }
    ],
    staticClass: "form-control",
    attrs: {
      type: "number",
      name: _vm.input_name,
      required: "",
      step: "any",
      max: "100000.00"
    },
    domProps: { value: _vm.price_model },
    on: {
      blur: _vm.hasBlur,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.price_model = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e4fc9f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e4fc9f1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseCurrencyInput.vue
// module id = 753
// module chunks = 0